import React, { useContext } from 'react';
import TestStatusSelector from '../TestStatusSelector';
import TestStatus from '../TestStatus';
import SelectBmcBlockTested from '../../Containers/Select/SelectBmcBlockTested';
import {
  bmcBlockTestedOptions,
  bmcBlockShortNames,
  testStatusBlocks,
} from '../../../../utils/factories/bmcBlocks';
import GlobalContext from '../../../../utils/GlobalContext';

const TestStatusBlock = ({
  isEditable,
  blocks,
  status,
  onBlocksUpdate,
  onStatusUpdate,
  textStyle,
  textColor,
}) => {
  const { locales } = useContext(GlobalContext);

  return (
    <div className="right">
      <div className="block custom-font-body">
        {isEditable ? (
          <SelectBmcBlockTested
            value={bmcBlockTestedOptions.filter((option) =>
              blocks.includes(option.value),
            )}
            onChange={onBlocksUpdate}
            textColor={textColor}
            textStyle={textStyle}
          />
        ) : (
          <>
            <div
              className={`title ${textStyle} custom-font-body`}
              style={{ color: textColor }}
            >
              {locales.testing.testCard.bmcBlocksTested}
            </div>
            <div className="content custom-font-title">
              {testStatusBlocks
                .filter((e) => blocks.includes(e))
                .map((e) => (
                  <div
                    key={e}
                    className={`bmc-blocks__block bmc-blocks__block-${e} custom-font-title`}
                  >
                    {bmcBlockShortNames[e]}
                  </div>
                ))}
            </div>
          </>
        )}
      </div>
      <div className="block">
        <div className="status test-card-section">
          {isEditable ? (
            <>
              <TestStatusSelector
                status={status}
                onStatusUpdate={onStatusUpdate}
                textStyle={textStyle}
                textColor={textColor}
              />
              <TestStatus status={status} textStyle={textStyle} />
            </>
          ) : (
            <>
              <div
                className={`header-status ${textStyle} custom-font-body`}
                style={{ color: textColor }}
              >
                {locales.testing.testCard.status}
              </div>
              <TestStatus status={status} textStyle={textStyle} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestStatusBlock;
